<template>
    <div class="widgetContainer">
        <div class="flexVertical">
          <span class="widgetTitle">{{getTitle()}}</span>
          <span class="widgetText">{{getFinished()}}</span>
          <span class="widgetText">{{getInProgress()}}</span>
        </div>
        <div style="margin-top: 8px; margin-right: 3px;">
          <dx-bar-gauge 
            :startValue="getStartValue()" 
            :endValue="getEndValue()"
            :values="[this.widgetdata.Finished]"
            :palette="getThresholdColorInternal()"
            :relativeInnerRadius="0.5">
              <dx-size :height="60" :width="60"/>
              <dx-label :visible="false" :customizeText="() => {}"/>
          </dx-bar-gauge>
        </div>
        <div class="align-self-end">
            <button class="closeButton" v-on:click="$emit('close-widget')">
                <font-awesome-icon class="closeButtonIcon" icon="window-close" size="xs"/>
            </button>
        </div>
    </div>
</template>
<script>
  // import DxContextMenu from 'devextreme-vue/context-menu';
  import DxBarGauge, {DxLabel, DxSize} from 'devextreme-vue/bar-gauge';
  import ThresholdColor from '@/mixins/ThresholdColor';
  
  export default {
    name: "WidgetCheckStatus",

    mixins: [ ThresholdColor ],

    components:{
      DxBarGauge,
      DxLabel,
      DxSize,
    },

    props: {
      widgetdata: { type: Object, default: null },
      thresholds: null,
    },

    created() {
      // console.log('WidgetCheckStatus - created');
    },

    mounted(){
      // console.log('WidgetCheckStatus - mounted');
    },

    beforeDestroy() {
      // console.log('WidgetCheckStatus - beforeDestroy');
    },

    data() {
      return {
      }
    },

    methods: {

      getTitle() {
        // console.log('WidgetTotalScore - getTitle');
        return this.widgetdata ? this.widgetdata.Title : "Check status:";
      },

      getEndValue() {
        let retVal = undefined;
        if (this.widgetdata.Finished !== 0 || this.widgetdata.InProgress !== 0) {
          retVal = this.widgetdata.Finished + this.widgetdata.InProgress;
        }

        return retVal;
      },

      getStartValue() {
        let retVal = undefined;
        if (this.widgetdata.Finished !== 0 || this.widgetdata.InProgress !== 0) {
          retVal = 0;
        }
        
        return retVal;
      },

      getFinished() {
        const label = this.widgetdata && this.widgetdata.FinishedLabel ? this.widgetdata.FinishedLabel : 'checks finished';
        return this.widgetdata && this.widgetdata.Finished != null ? this.widgetdata.Finished + ' ' + label : 'N/A ' + label;
      },

      getInProgress() {
        const label = this.widgetdata && this.widgetdata.InProgressLabel ? this.widgetdata.InProgressLabel : 'checks in progress';
        return this.widgetdata && this.widgetdata.InProgress != null ? this.widgetdata.InProgress + ' ' + label : 'N/A ' + label;
      },

      getThresholdColorInternal() {
        let retVal = 'Default';

        if (this.thresholds && this.widgetdata.Finished != NaN && this.widgetdata.InProgress != NaN) {
          const result = (this.widgetdata.Finished / (this.widgetdata.Finished + this.widgetdata.InProgress)) * 100;
          retVal = [this.getThresholdColor(this.thresholds, result, retVal)];
        }

        return retVal;
      }
    },

    computed: {
    }
  }
</script>
<style>
    .flexVertical {
        display: flex;
        flex-direction: column;
    }
</style>